export default __webpack_public_path__ + "static/media/6-small.f53a383b.png";